import { render, staticRenderFns } from "./ExchangeInventory.vue?vue&type=template&id=37e344dd&scoped=true&"
import script from "./ExchangeInventory.vue?vue&type=script&lang=js&"
export * from "./ExchangeInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e344dd",
  null
  
)

export default component.exports